
import log from 'loglevel';
// import rules from '../Action/rules/rules';

const handleInputEmailChange = (e, dispatch) => {

  let { value } = e.target;

  // remove whitespace from email input.
  value = value.trim();

  // convert into all lower case
  value = value.toLowerCase();
  log.debug('Page 3/Auth :- stored auth email into state : ', value);
  dispatch({
    type: 'ENTER_AUTH_EMAIL',
    payload: value,
  })
}

export default handleInputEmailChange;